/* NervaraLab · Produktseite: Galerie, Mengenwahl, Kombi, Sticky-Leiste, Swipe-Hinweise (Event-Delegation) */
(() => {
  if (window.__nvPdp) return; window.__nvPdp = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const fmt = (c) => (Math.max(0, c) / 100).toFixed(2).replace('.', ',') + ' €';
  const arrow = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  const setVariant = (inp) => {
    const root = inp.closest('[data-nvp]'); if (!root) return;
    const days = Number(root.dataset.days) || 0;
    const vid = $('[data-vid]', root); if (vid) vid.value = inp.value;
    const cents = Number(inp.dataset.cents), n = Number(inp.dataset.n) || 1;
    $$('[data-price]', root).forEach((e) => { if (!e.matches('input')) e.textContent = inp.dataset.price; });
    const u = $('[data-unit]', root); if (u) u.textContent = inp.dataset.unit || '';
    const pd = $('[data-perday]', root); if (pd && days) pd.textContent = 'Nur ' + fmt(Math.round(cents / (days * n))) + ' / Tag';
    const c = $('[data-cmp]', root); if (c) c.hidden = true;
    try { const url = new URL(location.href); url.searchParams.set('variant', inp.value); history.replaceState(null, '', url); } catch (e) {}
  };

  const comboSets = (box) => {
    if (!box._sets) {
      try { box._sets = JSON.parse(($('[data-sets]', box) || {}).textContent || '[]').filter((s) => s && s.v && s.i); } catch (e) { box._sets = []; }
    }
    return box._sets;
  };

  const comboCalc = (box) => {
    const ins = $$('input[type="checkbox"]', box);
    const sel = ins.filter((i) => i.checked && !i.disabled);
    const full = sel.reduce((s, i) => s + Number(i.dataset.cents), 0);
    const pct = sel.length >= 3 ? 10 : sel.length === 2 ? 5 : 0;
    const disc = sel.reduce((s, i) => s + Math.floor(Number(i.dataset.cents) * pct / 100 + 1e-9), 0);
    const key = sel.map((i) => i.dataset.h || '').sort().join(',');
    let setm = null;
    if (sel.length > 1) {
      const m = comboSets(box).find((s) => s.i.split(',').map((x) => x.trim()).sort().join(',') === key);
      if (m && Number(m.c) < full - disc) setm = m;
    }
    const set = (s, t) => { const e = $(s, box); if (e) e.textContent = t; };
    if (setm) {
      const sp = Math.round((full - setm.c) / full * 100);
      set('[data-sum-full]', fmt(full));
      set('[data-sum-lbl]', 'Als ' + setm.n + ' −' + sp + ' %');
      set('[data-sum-disc]', '−' + fmt(full - setm.c));
      set('[data-sum]', fmt(setm.c));
    } else {
      set('[data-sum-full]', pct ? fmt(full) : '');
      set('[data-sum-lbl]', pct ? 'Routine-Rabatt −' + pct + ' %' : 'Ab 2 Produkten −5 %');
      set('[data-sum-disc]', pct ? '−' + fmt(disc) : '');
      set('[data-sum]', fmt(full - disc));
    }
    const b = $('[data-combo-add]', box);
    if (b && !b.dataset.busy) { b.disabled = !sel.length; b.textContent = setm ? setm.n + ' in den Warenkorb' : sel.length > 1 ? sel.length + ' Produkte in den Warenkorb' : 'In den Warenkorb'; }
    return { sel, pct, setm };
  };

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t.matches && t.matches('input[name="nvp-v"]')) setVariant(t);
    const box = t.closest && t.closest('[data-nvp-combo]');
    if (box) comboCalc(box);
  });

  document.addEventListener('click', async (e) => {
    const add = e.target.closest && e.target.closest('[data-nvp-add]');
    if (add) {
      const root = add.closest('[data-nvp]'); const vid = root && $('[data-vid]', root);
      if (vid && window.nvCartAdd) window.nvCartAdd([{ id: Number(vid.value), quantity: 1 }], add);
      return;
    }
    const th = e.target.closest && e.target.closest('.nvp__thumb');
    if (th) {
      const gal = th.closest('[data-nvp-gal]'); const track = $('[data-track]', gal); const i = Number(th.dataset.i);
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      $$('.nvp__thumb', gal).forEach((t, k) => t.classList.toggle('is-on', k === i));
      return;
    }
    const cb = e.target.closest && e.target.closest('[data-combo-add]');
    if (cb) {
      const box = cb.closest('[data-nvp-combo]'); const { sel, pct, setm } = comboCalc(box);
      if (!sel.length || !window.nvCartAdd) return;
      cb.dataset.busy = '1';
      if (setm) {
        await window.nvCartAdd([{ id: Number(setm.v), quantity: 1 }], cb);
      } else {
        const code = pct === 10 ? box.dataset.c3 : pct === 5 ? box.dataset.c2 : '';
        if (code) { try { await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) }); } catch (err) {} }
        await window.nvCartAdd(sel.map((i) => ({ id: Number(i.value), quantity: 1 })), cb);
      }
      setTimeout(() => { delete cb.dataset.busy; comboCalc(box); }, 2300);
    }
  });

  document.addEventListener('scroll', (e) => {
    const t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-track]')) {
      const gal = t.closest('[data-nvp-gal]'); const i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
      $$('.nvp__thumb', gal).forEach((x, k) => x.classList.toggle('is-on', k === i));
      $$('.nvp__dots i', gal).forEach((x, k) => x.classList.toggle('is-on', k === i));
    } else if (t.matches('[data-rail]')) {
      const sw = t.nextElementSibling; if (!sw || !sw.classList.contains('nvp-swipe')) return;
      const items = t.children; const w = items[0] ? items[0].offsetWidth + 10 : 1;
      const i = Math.min(items.length - 1, Math.round(t.scrollLeft / w));
      $$('i', sw).forEach((d, k) => d.classList.toggle('is-on', k === i));
      if (t.scrollLeft > 20) sw.classList.add('is-done');
    }
  }, true);

  const setup = () => {
    $$('[data-nvp-combo]').forEach(comboCalc);
    const root = $('[data-nvp]');
    const bar = root && $('[data-nvp-bar]', root), cta = root && $('.nvp__cta', root);
    if (bar && cta && !bar.dataset.io && 'IntersectionObserver' in window) {
      bar.dataset.io = '1';
      new IntersectionObserver((es) => es.forEach((e) => bar.classList.toggle('is-on', !e.isIntersecting))).observe(cta);
    }
    if (!matchMedia('(max-width: 749px)').matches) return;
    $$('[data-rail]').forEach((r) => {
      if (r.nextElementSibling && r.nextElementSibling.classList.contains('nvp-swipe')) return;
      const n = r.children.length; if (n < 2) return;
      const sw = document.createElement('div'); sw.className = 'nvp-swipe'; sw.setAttribute('aria-hidden', 'true');
      sw.innerHTML = '<span class="nvp-swipe__dots">' + Array.from({ length: n }, (_, i) => '<i' + (i ? '' : ' class="is-on"') + '></i>').join('') + '</span><span class="nvp-swipe__hint">Wischen ' + arrow + '</span>';
      r.after(sw);
    });
    $$('[data-faq]').forEach((f) => {
      if (f.children.length < 5 || f.classList.contains('is-all') || (f.nextElementSibling && f.nextElementSibling.classList.contains('nvp-faqmore'))) return;
      const b = document.createElement('button'); b.type = 'button'; b.className = 'nvp-faqmore'; b.textContent = 'Alle ' + f.children.length + ' Fragen anzeigen';
      b.addEventListener('click', () => { f.classList.add('is-all'); b.remove(); });
      f.after(b);
    });
    $$('[data-clamp]').forEach((t) => {
      if (t.nextElementSibling && t.nextElementSibling.classList.contains('nvp-more')) return;
      t.classList.add('is-clamp');
      if (t.scrollHeight <= t.clientHeight + 4) { t.classList.remove('is-clamp'); return; }
      const b = document.createElement('button'); b.type = 'button'; b.className = 'nvp-more'; b.textContent = 'Weiterlesen';
      b.addEventListener('click', () => { const o = t.classList.toggle('is-open'); b.textContent = o ? 'Weniger anzeigen' : 'Weiterlesen'; });
      t.after(b);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  window.addEventListener('load', setup);
  setTimeout(setup, 1500);
})();